import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ChatComponent from './ChatComponent';

export default function ChatPage() {
    return (
        <Box sx={{ p: 3, height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
                Chat Corporativo
            </Typography>
            <Paper sx={{ flex: 1, overflow: 'hidden' }}>
                <ChatComponent />
            </Paper>
        </Box>
    );
}
